import { render, staticRenderFns } from "./MspPatientele.vue?vue&type=template&id=30ac9458&scoped=true&"
import script from "./MspPatientele.vue?vue&type=script&lang=ts&"
export * from "./MspPatientele.vue?vue&type=script&lang=ts&"
import style0 from "./MspPatientele.vue?vue&type=style&index=0&id=30ac9458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac9458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import DatePicker from '@cnamts/vue-dot/src/patterns/DatePicker'
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {DatePicker,VCol,VContainer,VRow})
